import { interpolatePath } from "./utils/path-interpolation";

export * from "./components/login-page/login-page.component";
export * from "./guards/login-page.guard";
export * from "./search-and-help-shared.module";

export const SahPathUtils = {
    interpolatePath: interpolatePath,
};
